import { Component } from '@angular/core';
import { MapService } from 'src/app/services/map.service';

import { Observable } from 'rxjs';

@Component({
  selector: 'app-trimble-map-controls',
  templateUrl: './map-controls.component.html',
  styleUrls: ['./map-controls.component.scss'],
})
export class MapControlsComponent {
  isMapLoading$: Observable<boolean>;

  constructor(private mapService: MapService) {
    this.isMapLoading$ = this.mapService.isLoading$;
  }

  zoomIn(): void {
    this.mapService.zoomIn();
  }

  zoomOut(): void {
    this.mapService.zoomOut();
  }

  printMap(): void {
    this.mapService.printMap();
  }
}
